(ns teamoesterreich.admin-mode.data.logs
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))



(defn <get-user-log-list [tomId done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/logs/toe/" tomId)
                  (fn [r-list status]
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] [(get e "log-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                        )))))

(defn <get-admin-log-list [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/logs/admin")
                  (fn [r-list status]
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] [(get e "log-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                        )))))

(defn <get-lrClearance-log-list [tomId done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/logs/lr-clearance/" tomId)
                  (fn [r-list status]
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] [(get e "log-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                        )))))


(defn <get-event-log-list [event-uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/logs/event/" event-uuid)
                  (fn [r-list status]
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] [(get e "log-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                        )))))


